<template>
    <div class="submit_container">
        <input class="field" type="text" autocomplete="email" v-model="email" :class="{ required: !is_email(email) }" placeholder="Введите адрес электронной почты" />
        <div v-if="is_success">Предложение отправлено на Вашу почту</div>
        <div v-if="is_error">Не удалось отправить предложение</div>
        <button :disabled="is_sending || !data || !is_email(email)" @click="submit()">
            <div class="indicator" v-if="is_sending">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="title">{{ get_title }}</div>
        </button>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "Sumbit",
    props: ["title", "data", "url"],
    emits: ["submit"],
    data() {
        return {
            email: "",
            is_sending: false,
            is_success: false,
            is_error: false,
        };
    },

    computed: {
        get_title() {
            if (this.is_sending) return "Идет отправка..."
            else return this.title
        },
    },

    methods: {
        is_email: function (email) {
            if (!email) return false;
            return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
        },

        submit: function () {
            this.is_sending = true;

            let formData = new FormData();
            formData.append("email", this.email);
            formData.append("tm", new Date());

            for (let key in this.data) {
                let param = this.data[key];
                if (typeof param == "object") {
                    param = JSON.stringify(param);
                }
                formData.append(key, param);                
            }

            axios
                .post(this.url, formData)
                .then((response) => {                    
                    this.is_sending = false;
                    if (response.data == "-ok") {                        
                        this.is_success = true;
                        this.is_error = false
                    } else {                        
                        this.is_success = false;
                        this.is_error = true
                    }
                })
                .catch(() => {
                    //console.log(e);
                    this.is_success = false;
                    this.is_error = true
                });
        },
    },
};
</script>

<style scoped>
.submit_container {
    padding: 0px;
    margin: 0px;
    display: flex;
    flex-direction: column;
}

.submit_container > button {
    background: white;
    border: 1px solid #fc5a0a;
    color: black;

    padding: 8px;
    margin-top: 15px;
    font-size: 12pt;
    font-weight: 600;
    opacity: 0.8;
    cursor: pointer;

    display: flex;
    flex-direction: row;
    justify-content: center;
}

.submit_container > button:hover {
    opacity: 1;
}

.submit_container > button:disabled {
    color: grey;
    border-color:grey;
}

.submit_container > button > .indicator {
    width: 17px;
    height: 17px;
    position: relative;
    overflow: hidden;
    margin: auto 5px;
}

.submit_container > button > .indicator > div {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    border: 2px solid;
    border-radius: 50%;
    border-color: orange transparent transparent transparent;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.submit_container > button > .indicator > div:nth-child(1) {
    animation-delay: -0.45s;
}

.submit_container > button > .indicator > div:nth-child(2) {
    animation-delay: -0.3s;
}

.submit_container > button > .indicator > div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
